import { createStyles, makeStyles } from '@material-ui/core';
import 'fontsource-montserrat/700.css';
import 'fontsource-montserrat/400.css';

const useStyles = makeStyles(() =>
  createStyles({
    '@global': {
      a: {
        outline: 'none !important'
      },
      'html, body, #root': {
        height: '100%',
        minHeight: '100%'
      },
      'p, h1, textarea': {
        fontFamily: 'Montserrat, sans-serif !important;'
      },
      '*': {
        'box-sizing': 'border-box'
      }
    }
  })
);

const GlobalStyles = () => {
  useStyles();
  return null;
};

export default GlobalStyles;
